<template>


    <div style="width: 1100px; height: 650px; margin: 80px auto; ">
        <el-card class="box-card" style="border-radius: 20px; width: 1100px; height: 750px; margin-top: auto">

            <div style="width: 100%;height: 120px;line-height: 120px; padding-left:  15%;">
              <span style="font-size: 38px">
                湖南御码网控信息技术有限公司OA系统
              </span>
            </div>
            <div style="height: 400px">
            <el-row :gutter="100">
                <el-col :span="16">
                    <img style="width: 100%" :src="require('@/assets/login13.png')">
                </el-col>
                <el-col :span="8" style="margin-top: 150px; ">
                     <el-image style="width: 60%" :src="url">
                    <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                    </div>
                         <div slot="error" class="image-slot">
                             <i class="el-icon-picture-outline"></i>
                         </div>
                     </el-image>
                    <br/>
                    <br/>
                    <br/>
                    <span style="color: rgb(121,112,127);padding-left: 15px;">  请使用微信扫码登录</span>
                </el-col>
            </el-row>
            </div>

            <div style="clear:both;height:70px; padding-top: 30px;text-align: center;  color: #a8a8a8;    font-size: 12px;    width: 700px;      margin: 0 auto; ">
                <div style="height: 16px;    line-height: 16px;    margin-bottom: 5px; text-align:center;">
                    YMWK-OA
                </div>
                <div style="height: 16px;    line-height: 16px;    margin-bottom: 5px; text-align:center;">
                    ICP备1364512493号
                </div>
                <div style="height: 16px;    line-height: 16px;    margin-bottom: 5px; text-align:center;">
                    Copyright © 2023-至今 湖南御码网控信息技术有限公司 All Rights Reserved.
                </div>
            </div>
        </el-card>
    </div>


</template>
<script>
    import {apiServer} from "@/util"
    import {
        requestLogin,
        requestGetToken,
    } from "../api";
    import {
        AesEncrypt,
    } from "../util";
    export default {
        data() {
            return {
                notifyIndex: {},
                apiServer: apiServer,
                url:'',
                token: '',
                interval:0,
            }
        },
        created() {
            this.getToken();

        },
        methods: {
            async getToken(){
              const res = await requestGetToken();
              if(res.code == 200){
                this.token = res.object;
                this.url=apiServer+'sysQrLogin/loginQrImage?token='+res.object;
                this.login();
              }else{
                this.$message.error("获取登录token失败")
              }
            },
            login() {
                let that = this;
                this.interval = window.setInterval(()=>{
                    let param = {"token": that.token};
                    requestLogin(param).then(res =>{
                        if(res.code == 300){
                            //用户扫码中
                        }else if(res.code == 200){
                            //扫码成功 保存jwt 保存用户信息
                            let user = res.object.user;
                            let jwt = res.object.jwt;
                            window.localStorage.setItem("user",AesEncrypt(JSON.stringify(user)));
                            window.localStorage.setItem("jwt",jwt);
                            window.clearInterval(that.interval);
                            that.$router.push("/home")
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(err => {
                        window.clearInterval(that.interval);
                    })
                },1000)
            }
        }


    }
</script>
<style scoped>

    /* 如果屎全屏展示 */
    .login-bg {
        width: 100%;
        height: 100%;
    }

    .title-login {
        text-align: center;
    }


    /* 登陆页面 */
    .login_container {
        /*background-color: #409EFF;*/
        background-color: white;
        height: 100%;
    }

    /* 登陆框盒子 */
    .login_box {
        width: 450px;
        height: 350px;
        background-color: #ffffff;
        /* opacity: 0.9; */
        border-radius: 10px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    /* 头像盒子 */
    .avatar_box {
        height: 130px;
        width: 130px;
        border: 1px solid #FFFFFF;
        border-radius: 50%;
        padding: 10px;
        box-shadow: 0 0 10px #FFFFFF;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        /* background-color: #FFFFFF; */
    }

    /* 头像img */
    .avatar_box img {
        height: 100%;
        width: 100%;
        border-radius: 50%;
        background-color: #FFFFFF;
        border: 1px solid #409EFF;
        box-shadow: 0 0 10px #409EFF;
    }

    /* 登陆表单 */
    .login_from {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 30px;
        box-sizing: border-box;
    }

    /* 按钮右对齐 */
    .btns {
        display: flex;
        justify-content: flex-end;
    }

    /* 按钮样式重写 */
    .btn_font {
        width: 100px;
        border-radius: 4px;
        color: #409EFF;
    }

    .btn_font:hover {
        color: #FFFFFF;
        background-color: #409EFF;
    }

    /* 验证码盒子 */
    .code_box {
        height: 40px;
        width: 100%;
    }

    .code_box img {
        width: 128px;
        height: 39px;
        border: 1px solid #eee;
        border-radius: 4px;
    }


</style>
